var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-list-group',{staticClass:"flex-wrap p-1",attrs:{"horizontal":_vm.width < 100}},_vm._l((_vm.items),function(item,i){return _c('b-list-group-item',{key:i,class:_vm.class_},[_c('div',{domProps:{"innerHTML":_vm._s(item)}})])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }